"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrCatch = getOrCatch;
function getOrCatch(getValue) {
    try {
        const value = getValue();
        if (value instanceof Promise) {
            return value.then((value) => ({ value })).catch((error) => ({ error }));
        }
        else {
            return { value };
        }
    }
    catch (error) {
        return { error };
    }
}
//# sourceMappingURL=getOrCatch.js.map